'use client';
import './Step.scss';
import {ReactNode, forwardRef, Ref} from 'react';

type StepProps = {
  children?: ReactNode;
  number: number | string;
  t: (string:string) => string;
  small?: boolean;
};

export const Step = forwardRef<HTMLHeadingElement, StepProps>(
    ({ children, number, t, small }, ref: Ref<HTMLHeadingElement>) => {
      return (
          <h2 className={`step ${ small ? 'step--sm' : ''}`} ref={ref}>
            <span className={'step__number'}>{number}</span>
            {children ? t(children as string) : ''}
          </h2>
      );
    }
);